import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../assets/logo.png";
import {
  MdKeyboardArrowRight,
  MdKeyboardArrowDown,
  MdMenu,
  MdClose,
} from "react-icons/md";

const Header = () => {
  const [submenuItems, setSubmenuItems] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [nestedSubmenuOpen, setNestedSubmenuOpen] = useState(false);
  const [bodySubmenuOpen, setBodySubmenuOpen] = useState(false);
  const [hoverSubmenuOpen, setHoverSubmenuOpen] = useState(null);

  useEffect(() => {
    fetch("/products.json")
      .then((res) => res.json())
      .then((data) => setSubmenuItems(data.categories || []))
      .catch((err) => console.error("Error loading submenu items:", err));
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <nav className="header bg-primary w-full left-0 z-50">
      <div className="navbar container mx-auto flex justify-between items-center h-16 px-4">
        <a href="/">
          <img src={logo} alt="Logo" className="h-10 object-contain" />
        </a>

        {/* Desktop Navigation */}
        <ul className="nav-links hidden md:flex gap-8">
          <li><a href="/">HOME</a></li>
          <li><a href="/about">ABOUT US</a></li>

          {/* Products Dropdown */}
          {submenuItems.length > 0 && (
            <li className="has-submenu relative group">
              <a href="/" className="flex items-center">
                PRODUCTS <MdKeyboardArrowDown className="ml-1 text-lg" />
              </a>
              <ul className="submenu absolute top-full left-0 bg-white shadow-md p-2 hidden group-hover:block min-w-[200px]">
                {submenuItems[0] && submenuItems[0].products.slice(0, 2).map((item) => (
                  <li key={item.id}>
                    <a href={`/product/${item.slug}`}>{item.name}</a>
                  </li>
                ))}

                {submenuItems[1] && (
                  <li
                    className="relative "
                    onMouseEnter={() => setHoverSubmenuOpen("second")}
                    onMouseLeave={() => setHoverSubmenuOpen(null)}
                  >
                    <a href="/" className="flex items-center">
                      {submenuItems[1].category_name}
                      <MdKeyboardArrowRight className="ml-1 text-lg" />
                    </a>
                    {hoverSubmenuOpen === "second" && (
                      <ul className="absolute -top-5 left-full bg-white shadow-md p- min-w-[220px] ">
                        {submenuItems[1].products.map((item) => (
                          <li key={item.id}>
                            <a href={`/product/${item.slug}`}>{item.name}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )}

                {submenuItems[2] && (
                  <li
                    className="relative"
                    onMouseEnter={() => setHoverSubmenuOpen("body")}
                    onMouseLeave={() => setHoverSubmenuOpen(null)}
                  >
                    <a href="/" className="flex items-center">
                      {submenuItems[2].category_name}
                      <MdKeyboardArrowRight className="ml-1 text-lg" />
                    </a>
                    {hoverSubmenuOpen === "body" && (
                      <ul className="absolute top-0 left-full bg-white shadow-md p-2 min-w-[200px]">
                        {submenuItems[2].products.map((item) => (
                          <li key={item.id}>
                            <a href={`/product/${item.slug}`}>{item.name}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )}
              </ul>
            </li>
          )}

          <li><a href="/faq">FAQ</a></li>
          <li><a href="/contact">CONTACT US</a></li>
        </ul>

        {/* Mobile Toggle */}
        <button className="text-white text-2xl md:hidden" onClick={toggleSidebar}>
          {isSidebarOpen ? <MdClose /> : <MdMenu />}
        </button>
      </div>

      {/* Mobile Sidebar */}
      <div className={`fixed top-0 left-0 h-full w-64 bg-black bg-opacity-80 text-white transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} transition-transform duration-500 z-40`}>
        <div className="flex justify-between items-center h-16 px-4">
          <img src={logo} alt="Logo" className="h-10 object-contain" />
          <button onClick={toggleSidebar} className="text-2xl"><MdClose /></button>
        </div>

        <ul className="flex flex-col gap-4 p-4 font-bold text-sm">
          <li><a href="/" onClick={toggleSidebar}>HOME</a></li>
          <li><a href="/about" onClick={toggleSidebar}>ABOUT US</a></li>

          {submenuItems.length > 0 && (
            <li className="relative">
              <button
                onClick={() => setSubmenuOpen(!submenuOpen)}
                className="flex items-center w-full text-left py-2 text-white"
              >
                PRODUCTS
                <MdKeyboardArrowDown className={`ml-2 text-lg ${submenuOpen ? "rotate-180" : ""}`} />
              </button>
              {submenuOpen && (
                <ul className="mt-2 bg-gray-800">
                  {submenuItems[0] && submenuItems[0].products.slice(0, 2).map((item) => (
                    <li key={item.id}>
                      <a
                        href={`/product/${item.slug}`}
                        className="block px-4 py-2 text-gray-200 hover:bg-gray-700"
                        onClick={toggleSidebar}
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}

                  {submenuItems[1] && (
                    <li className="relative">
                      <button
                        onClick={() => setNestedSubmenuOpen(!nestedSubmenuOpen)}
                        className="flex items-center w-full px-4 py-2 text-white"
                      >
                        {submenuItems[1].category_name}
                        <MdKeyboardArrowRight className={`ml-auto text-lg ${nestedSubmenuOpen ? "rotate-90" : ""}`} />
                      </button>
                      {nestedSubmenuOpen && (
                        <ul className="bg-gray-900">
                          {submenuItems[1].products.map((item) => (
                            <li key={item.id}>
                              <a
                                href={`/product/${item.slug}`}
                                className="block px-6 py-2 text-gray-300 hover:bg-gray-700"
                                onClick={toggleSidebar}
                              >
                                {item.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}

                  {submenuItems[2] && (
                    <li className="relative">
                      <button
                        onClick={() => setBodySubmenuOpen(!bodySubmenuOpen)}
                        className="flex items-center w-full px-4 py-2 text-white"
                      >
                        {submenuItems[2].category_name}
                        <MdKeyboardArrowRight className={`ml-auto text-lg ${bodySubmenuOpen ? "rotate-90" : ""}`} />
                      </button>
                      {bodySubmenuOpen && (
                        <ul className="bg-gray-900">
                          {submenuItems[2].products.map((item) => (
                            <li key={item.id}>
                              <a
                                href={`/product/${item.slug}`}
                                className="block px-6 py-2 text-gray-300 hover:bg-gray-700"
                                onClick={toggleSidebar}
                              >
                                {item.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

          <li><a href="/faq" onClick={toggleSidebar}>FAQ</a></li>
          <li><a href="/contact" onClick={toggleSidebar}>CONTACT</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
